<template>
  <div class="box-second">
    <p class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>考勤机管理</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="build-bar">
        <el-button
          type="primary"
          @click="addRow()"
        >绑定考勤机</el-button>
      </div>
      <div class="build-table">
        <el-table
          :data="tableDataEnd"
          ref="tableDataBegin"
          height="100%"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{ dataText }}</p>
          </template>
          <el-table-column
            label="序号"
            width="80"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Sn号">
            <template slot-scope="scope">
              <a>{{ scope.row.imei }}</a>
            </template>
          </el-table-column>
          <el-table-column label="进/出闸">
            <template slot-scope="scope">
              <span>{{ scope.row.statusName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属项目">
            <template slot-scope="scope">
              <span>{{ scope.row.projectName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="在线时间">
            <template slot-scope="scope">
              <span>{{ scope.row.updateDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>

          <!-- 新增窗口 -->
          <el-dialog
            top="3vh"
            :title="dialogTitle"
            :visible.sync="addFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
          >
            <el-form
              :model="addForm"
              ref="addForm"
              label-width="140px"
              :label-position="labelPosition"
              :rules="rules"
            >
              <el-form-item label="设备名称：">
                <el-input
                  v-model="projectName"
                  :disabled="true"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="考勤机Sn："
                prop="imei"
              >
                <el-input
                  v-model="addForm.imei"
                  placeholder="请输入Sn"
                  autocomplete="off"
                  :disabled="addForm.id != ''"
                >天门湖项目</el-input>
              </el-form-item>
              <el-form-item
                label="进出类型："
                prop="inoutType"
              >
                <el-select
                  v-model="addForm.inoutType"
                  @change="inputA"
                >

                  <el-option
                    v-for="(item, index) in useTypes"
                    :key="index"
                    :label=item.label
                    :value=item.value
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="设备类型："
                prop="status"
              >
                <el-select v-model="addForm.status">
                  <el-option
                    v-for="item in typeNameAll"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="厂家：">
                <el-select v-model="addForm.machType">
                  <el-option
                    v-for="item in millNameAll"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否开启防疫功能："
                v-show="addForm.isAKControl != ''"
              >
                <el-select v-model="addForm.isAKControl">
                  <el-option
                    label="不开启"
                    value="0"
                  ></el-option>
                  <el-option
                    label="开启"
                    value="1"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="云筑网应用ID：" prop="appId">
                        <el-input v-model="addForm.appId" placeholder="请输入应用ID" autocomplete="off">天门湖项目</el-input>
                    </el-form-item>
                    <el-form-item label="云筑网应用密钥：" prop="appSecuret">
                        <el-input v-model="addForm.appSecuret" placeholder="请输入应用密钥" autocomplete="off">天门湖项目</el-input>
                    </el-form-item> -->
              <el-form-item label="位置:">
                <el-input
                  type="textarea"
                  v-model="addForm.locationDesc"
                ></el-input>
              </el-form-item>
            </el-form>
            <div
              slot="footer"
              class="dialog-footer"
            >
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button
                type="primary"
                @click="sumbitAddRow('addForm')"
              >确 定</el-button>
            </div>
          </el-dialog>
        </el-table>

        <!-- 表单列表 -->
        <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>-->
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
  data () {
    return {
      useTypes: [],// 进出类型
      // projectId: '',
      typeNameAll: [
        // { status: '进闸', value: '0' },
        // { status: '出闸', value: '1' },
        // { status: '未配置', value: '2' },
        // { status: '采集机', value: '4' },
        // { status: '特种使用', value: '5' }
      ], // 类型下拉菜单组
      status: '进闸', // 类型下拉菜单默认值
      millNameAll: [], // 厂家下拉菜单组
      machType: '零视', // 厂家下拉菜单默认值
      dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: [], // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      projectName: '',
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      rules: {
        imei: [
          { required: true, message: '请输入考勤机Sn号', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择进出类型', trigger: 'blur' }
        ],
        inoutType: [
          { required: true, message: '请选择设备类型', trigger: 'blur' }
        ],
      },
    }
  },
  mounted () {
    this.getData()
    // this.getList()
    this.getDict()
    this.getDict1()
    this.getUseType()

  },
  methods: {

    //获取使用类型字典 mt_useType
    getUseType () {
      var that = this
      myHttp.getDictByType({
        type: 'installation_site'
      }).then(function (resp) {
        if (resp.data.code == '200') {

          that.useTypes = resp.data.data.dictList
          console.log('获取到进出类型===================>', that.useTypes);
          // that.getData()
        }
      })
    },
    inputA (val) {
      this.addForm.status = ''
      if (val === '1' || val === '2') {
        // this.addForm.typeNameAll = [

        // ]
        var that = this
        that.typeNameAll = []
        myHttp.getDictByType({
          type: 'attend_type'
        })
          .then(function (resp) {
            if (resp.data.code == '200') {
              resp.data.data.dictList.forEach(item => {
                if (item.value !== '5') {
                  that.typeNameAll.push(item)
                }
              })
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      } else if (val === '3' || val === '4') {
        this.typeNameAll = [
          { label: '特种使用', value: '5' },
        ]
      } else if (val === '5') {
        this.typeNameAll = [
          { label: '进闸', value: '0' },
          { label: '其他', value: '3' }
        ]
      }
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`)
    //   this.currentPage = val
    //   this.getData()
    // },.
    // // 监控当前页码
    // currentChangePage() {
    //   this.getData()
    // },

    // 获取数据
    getData () {
      var that = this
      myHttp.getProjectById({
        id: util.session.get('groupId')
      }).then(
        function (resp) {
          if (resp.data.code == '200') {
            that.projectName = resp.data.data.project.name
          }
        },
        function () { }
      )
    },

    //获取列表
    getList () {
      var option = {
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getMachineList(option).then(
        function (resp) {
          //var projectName = "";
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo || []
            for (var i = 0; i < list.length; i++) {
              //that.projectName = list[i].projectName;
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].statusName = that.filterSatus(list[i].status)
            }
            that.tableDataEnd = list
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function () { }
      )
    },

    //获取类型
    filterSatus (str) {
      var list = this.typeNameAll
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },

    // 编辑数据
    handleEdit (index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      if (row.inoutType == '施工') {
        row.inoutType = '1'
      } else if (row.inoutType == '生活') {
        row.inoutType = '2'
      } else if (row.inoutType == '塔吊') {
        row.inoutType = '3'
      } else if (row.inoutType == '升降机') {
        row.inoutType = '4'
      } else if (row.inoutType == '访客') {
        row.inoutType = '5'
      }
      this.addForm = row
      if (row.settings) {
        this.addForm.isAKControl = JSON.parse(row.settings).isAKControl
      } else {
        this.addForm.isAKControl = ''
      }

    },

    // 删除数据 111
    handleDelete (index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.machineDeleteInfo({
          id: row.id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
    /**
     * 新增设备
     */
    addRow () {
      this.dialogTitle = '考勤机绑定'
      this.addFormVisible = true
      this.addForm = {
        projectName: this.projectName,
        imei: '',
        status: '',
        machType: '',
        id: '',
        projectId: util.session.get('groupId'),
        locationDesc: '',
        inoutType: '',
        isAKControl: ''
      }
      var that = this
      myHttp.getDictByType({
        type: 'attend_type'
      })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.typeNameAll = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },

    // 将新增的数据添加到表格中
    sumbitAddRow (formName) {
      var that = this
      // console.log(that.addForm)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            if (that.addForm.password == '') {
              that.$message.error('创建时请输入密码！')
              return
            }
            that.addForm.id = that.addForm.imei
            //添加 222
            myHttp.machineCreateInfo(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getData()
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () { }
            )
          } else {
            //修改 1111
            if (this.addForm.settings) {
              let data = JSON.parse(this.addForm.settings)
              data.inandoutdoor = this.addForm.status
              data.isAKControl = this.addForm.isAKControl
              this.addForm.settings = JSON.stringify(data)
            }
            delete that.addForm.createDate
            delete that.addForm.updateDate
            delete that.addForm.setDate
            // delete that.addForm.sqlMap
            if (that.addForm.password == '') {
              delete that.addForm.password
            }
            myHttp.machineCreateInfo(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () { }
            )
          }
        }
      })
    },
    cancel () {
      this.addFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },
    // 字典接口
    // getPageList
    getDict () {
      var that = this
      myHttp.getDictByType({
        type: 'attend_type'
      })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.typeNameAll = resp.data.data.dictList

            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    getDict1 () {
      var that = this
      myHttp
        .getDictByType({
          type: 'mach_type'
        })
        .then(function (resp) {
          console.log(resp);
          if (resp.data.code == '200') {
            that.millNameAll = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    }
  }
}
</script>
<style scoped>
.box-second {
  width: 100%;
  height: 100%;
  position: relative;
}

.title {
  width: 100%;
  height: 3vh;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  padding-left: 1vw;
}

.main {
  width: 100%;
  height: calc(100% - 3vh);
  position: relative;
  display: flex;
  padding: 0 1vw 0.5vw;
  flex-wrap: wrap;
}

.build-bar {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 8vh;
  /* border-top: 3px solid rgb(224, 224, 224); */
  border-bottom: 3px solid #17b2fe;
  background: #fff;
}

.build-bar span {
  margin-left: 30px;
  white-space: nowrap;
  display: inline-block;
}

.build-bar>.el-input {
  width: 200px;
  font-size: 12px;
}

.build-bar>.el-button {
  margin-left: 30px;
  background-color: #17b2fe;
  border-color: #17b2fe;
}

.build-bar>.el-button:last-child {
  margin-right: 20px;
}

.build-bar .btnLef {
  position: absolute;
  right: 6%;
  display: block;
  width: 95px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
  background: #ffaf15;
  border: 1px solid #ffb800;
}

.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.build-table {
  position: relative;
  width: 100%;
  background: #fff;
  height: calc(100% - 8vh);
  /* margin: 0 auto; */
}

.el-table .el-table-column:not(:first-child) {
  border: 1px solid slategrey;
}

.el-table>>>.cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.add-form {
  margin-top: 10vh;
}

.add-form .el-form-item {
  margin-top: 30px;
}

.el-pagination {
  padding: 20px 0;
}
</style>
<style>
@import '../../../assets/css/common.css';
</style>